import React from "react"
import {RefTable, DefaultProps} from "../RefTable"

export const SalesType = (props)=><RefTable {...props}/>;

SalesType.defaultProps = {
    ...DefaultProps,
    title: "Sales Types",
    tableSchema: "sales_type",
    tableName: "sales_type",
    edit: true,
    theadHeight: 64
}
